export const SET_MACHINE_READABLE_TEMPLATES =
  'mrt/SET_MACHINE_READABLE_TEMPLATES';
